import { Button, Modal, Message, Table, Router, setRoute, useWindowContext, noop } from '@iqueue/ui-kit'
import { useState, useCallback, useEffect, useMemo, useRef } from 'react'
import useTranslate, { t } from '../../hooks/useTranslate'
import UserProfilePresenter from '../../api/userProfilePresenter'
import { fetcherGet } from '../../api/fetcher'
import BasicDateRenderer from '../../utils/renderers'

export default function UserProfilePage() {
  const [tgToken, setTgToken] = useState(null)
  const [activeSessions, setActiveSessions] = useState([])
  const tableRef = useRef()
  const locale = useTranslate()
  const { togglePaddings, setTitle, toggleScrollbars } = useWindowContext()

  const translatedTitle = useMemo(() => t('profilePage.title'), [locale])

  const schema = useMemo(() => {
    return [
      {
        key: 'telegram',
        title: t('profilePage.telegramId'),
        render: (v) => <b>{ v }</b>,
      },
      {
        key: 'createdAt',
        title: t('profilePage.createdAt'),
        render: BasicDateRenderer,
        width: '20rem',
      },
      {
        key: 'updatedAt',
        title: t('profilePage.updatedAt'),
        render: BasicDateRenderer,
        width: '20rem',
      },
      {
        key: 'id',
        width: '4.4rem',
        render: (_, item) => (
          <Button
            danger
            icon={ 'delete' }
            onClick={ () => {
              handleConfirmDetach(item.telegram).catch((err) => console.error(err))
            } }
          />
        ),
      },
    ]
  }, [locale])

  const handleConfirmAttach = useCallback(async () => {
    UserProfilePresenter.post(`telegram/attach/${ tgToken }`)
      .then(() => {
        fetcherGet('v1/user-integration/telegram')
          .then(setActiveSessions)
          .then(() => setRoute('/user-integration', true, true))
      })
      .catch((err) => {
        Message({
          type: 'error',
          timeout: 5000,
          title: err?.message,
        })
      })
  }, [tgToken])

  const handleConfirmDetach = useCallback(async (id) => {
    UserProfilePresenter.post(`telegram/detach/${ id }`)
      .then(() => {
        setActiveSessions((prevSessions) => prevSessions.filter((session) => session.telegram !== id))
      })
      .catch((err) => {
        Message({
          type: 'error',
          timeout: 5000,
          title: err?.message,
        })
      })
  }, [])

  useEffect(() => {
    fetcherGet('v1/user-integration/telegram').then(setActiveSessions)
  }, [])

  useEffect(() => {
    setTitle(translatedTitle)
    togglePaddings(true)
    toggleScrollbars(true)
  }, [translatedTitle])

  return <>
    <Router
      level={ 1 }
      render={ (token) => {
        if (!token || !token.startsWith('tg-')) return false

        return <Button
          secondary
          onClick={ () => setTgToken(token.substring(3)) }
          title={ t('profilePage.attachTelegram') }
        />
      } }
    />

    { activeSessions.length !== 0 && (
      <Table indexable ref={ tableRef } schema={ schema } entries={ activeSessions } minWidth={ '60rem' }/>
    ) }

    <Modal
      title={ t('profilePage.confirmAttach') }
      isOpened={ !!tgToken }
      onClose={ () => setTgToken(null) }
      footerActions={ [
        { key: 'cancel', title: t('profilePage.cancel') },
        { key: 'apply', title: t('profilePage.apply'), submit: true, primary: true, onClick: handleConfirmAttach },
      ] }
    />
  </>
}
